import { atom } from 'nanostores'
import type { ServiceLevelStatus } from '~/types/service-level'

export const $serviceLevelStatus = atom<ServiceLevelStatus | null>(null)
